import styled from 'styled-components';

const Dropdown = styled.span`
  position: relative;
  min-width: 200px;
`;

const DropdownMenu = styled.div`
  padding-top: 6px;
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  min-width: 184px;
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-4px);
  transition: all 300ms ease-in-out;

  .dropdown-list {
    background-color: ${props => props.theme.primary.raju};
    border-radius: 4px;
    box-shadow: 0 8px 40px -8px rgba(0, 0, 0, 0.15);
    overflow-y: scroll;
    max-height: 264px;
    max-width: 200px;

    .dropdown-list-item {
      display: block;
      padding: 10px 20px;
      color: #4a4a4a;
      font-size: 14px;
      transition: all 0.2s ease-in;
      line-height: 1.4;
      cursor: pointer;
      font-weight: 400;
      text-align: left;
      &:not(:last-child) {
        border-bottom: 1px solid #e4eaeb;
      }
      &:hover {
        color: ${props => props.theme.primary.ujyaalo};
        cursor: pointer;
      }
      > a {
        color: grey;
        white-space: nowrap;
        &.active {
          color: ${props => props.theme.primary.ujyaalo};
        }

        &:hover {
          color: ${props => props.theme.primary.ujyaalo};
          cursor: pointer;
        }
      }
    }
  }
`;

const transitionStyles = {
  entered: {
    opacity: 1,
    visibility: 'visible',
    transform: 'translateY(0)'
  }
};

export { Dropdown, DropdownMenu, transitionStyles };



// WEBPACK FOOTER //
// ./src/components/layouts/dropdowns/dropdownStyles.js